import axios from '../../axios';
import templates from './templates';

export default {
  namespaced: true,
  state: {
    allProperties: null,
    currentPropertyId: null,
    currentProperty: null,
    currentPropertyAmenities: null,
    currentPropertyReviews: null,
    currentPropertyPressArticles: null,
    currentPropertyAvailability: null,
    currentPropertyHouseGuide: null,
  },
  getters: {
    getPropertyCardById: (state, getters) => (id) => {
      if (state.allProperties) {
        return state.allProperties.find((x) => x.id === id);
      }
    },
    getAllproperties: (state) => {
      if (state.allProperties) {
        return state.allProperties;
      }
    },
    getCurrentProperty: (state) => {
      if (state.currentProperty) {
        return state.currentProperty;
      }
    },
    getCurrentPropertyId: (state) => {
      if (state.currentPropertyId) {
        return state.currentPropertyId;
      }
    },
    getCurrentPropertyAmenities: (state) => {
      if (state.currentPropertyAmenities) {
        return state.currentPropertyAmenities;
      }
    },
    getCurrentPropertyHouseGuide: (state) => {
      if (state.currentPropertyHouseGuide) {
        return state.currentPropertyHouseGuide;
      }
    },
    getCurrentPropertyReviews: (state) => {
      if (state.currentPropertyReviews) {
        return state.currentPropertyReviews;
      }
    },
    getCurrentPropertyPressArticles: (state) => {
      if (state.currentPropertyPressArticles) {
        return state.currentPropertyPressArticles;
      }
    },
    getCurrentAvailabilityFilters: (state) => {
      const filters = {
        dates: {
          start: new Date(),
          end: new Date(),
        },
        people: {
          adults: 0,
          children: 0,
          babies: 0,
        },
        currency: 'EUR',
        rooms: {
          singles: 0,
          doubles: 0,
          twins: 0,
          triples: 0,
          quads: 0,
          five: 0,
          six: 0,
          bunks: 0,
        },
      };
      return filters;
    },
    getCurrentPropertyAvailability: (state) => {
      if (state.currentPropertyAvailability) {
        return state.currentPropertyAvailability;
      }
    },
    getProperyByURL: (state, getters) => (url) => {
      if (state.allProperties) {
        return state.allProperties.find((p) => p.url === url);
      }
    },
    getProperyById: (state, getters) => (id) => {
      if (state.allProperties) {
        return state.allProperties.find((p) => p.id === Number(id));
      }
    },
  },
  mutations: {
    setCurrentPropertyId(state, data) {
      state.currentPropertyId = data;
    },
    setCurrentProperty(state, data) {
      state.currentProperty = data;
    },
    setCurrentPropertyAmenities(state, data) {
      state.currentPropertyAmenities = data;
    },
    setCurrentPropertyReviews(state, data) {
      state.currentPropertyReviews = data;
    },
    setCurrentPropertyPressArticles(state, data) {
      state.currentPropertyPressArticles = data;
    },
    setCurrentPropertyPriceRange(state, data) {
      state.currentPropertyPriceRange = data;
    },
    setCurrentPropertyAvailability(state, data) {
      state.currentPropertyAvailability = data;
    },
    setAllproperties(state, data) {
      state.allProperties = data;
    },
    setCurrentPropertyHouseGuide(state, data) {
      state.currentPropertyHouseGuide = data;
    },
  },
  actions: {
    fetchPropertyById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      return new Promise((resolve, reject) => {
        state.currentProperty = null;
        axios.get(`/core/properties/${id}/lang/${rootGetters['pages/currentLang']}`)
          .then((res) => {
            commit('setCurrentProperty', res.data);
            resolve(res.data);
          });
      });
    },
    fetchPropertySlideshowById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      return new Promise((resolve, reject) => {
        state.currentProperty = null;
        axios.get(`/core/properties/${id}/lang/${rootGetters['pages/currentLang']}`)
          .then((res) => {
            resolve(res.data.slideshowId);
          });
      });
    },
    fetchPropertyAmenitiesById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      state.currentPropertyAmenities = null;
      axios.get(`/core/properties/${id}/amenities/lang/${rootGetters['pages/currentLang']}`)
        .then((res) => {
          commit('setCurrentPropertyAmenities', res.data);

          // Indicate to prerender.io that the page is complete
          dispatch('pages/setPreRenderDone', null, { root: true });
        });
    },
    fetchPropertyReviewsById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      commit('setCurrentPropertyReviews', null);
      axios.get(`/core/properties/${id}/reviews`)
        .then((res) => {
          commit('setCurrentPropertyReviews', res.data);
        });
    },
    fetchPropertyPressArticlesById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      commit('setCurrentPropertyPressArticles', null);
      axios.get(`/core/properties/${id}/pressarticles`)
        .then((res) => {
          commit('setCurrentPropertyPressArticles', res.data);
        });
    },
    fetchPropertyHouseGuideURLById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/properties/${id}/housepackurl/lang/${rootGetters['pages/currentLang']}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchPropertyHouseGuideById({
      commit, state, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        commit('setCurrentPropertyHouseGuide', null);
        axios.get(`/core/properties/${data.id}/houseguide`, { params: { houseGuideType: data.type } })
          .then((res) => {
            commit('setCurrentPropertyHouseGuide', res.data);
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchPropertyUsefulInformationById({
      commit, state, dispatch, getters, rootGetters,
    }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/properties/${id}/usefulregioninfomation`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchPropertyAvailability({
      commit, state, dispatch, getters, rootGetters,
    }, data) {
      // if current year then only get blocks from now to end of year, else for the full given year
      const dtfrom = moment(data.filters.arrival).year() == new Date().getFullYear() ?
        moment(new Date()) :
        moment([moment(data.filters.arrival).year(), 1, 1]);

      const dtto = moment({ year: moment().year() + 1, month: 11, day: 31 });

      // set this instance to use english. Api cannot handle the dates in other locales
      dtfrom.locale('en');
      dtto.locale('en');

      axios.get(`/core/properties/${data.propertyId}/availability`, {
        params: {
          from: dtfrom.format('DD MMM YYYY'),
          to: dtto.format('DD MMM YYYY'),
          adults: data.filters.people.adults,
          children: data.filters.people.children,
          infants: data.filters.people.babies,
          rooms_single: data.filters.rooms.singles,
          rooms_double: data.filters.rooms.doubles,
          rooms_twin: data.filters.rooms.twins,
          rooms_triple: data.filters.rooms.triples,
          rooms_quad: data.filters.rooms.quads,
          rooms_five: data.filters.rooms.five,
          rooms_six: data.filters.rooms.six,
          rooms_bunk: data.filters.rooms.bunk,
          blocksize: 1,
        },
      })
        .then((res) => {
          commit('setCurrentPropertyAvailability', res.data);
        });
    },
    // fetchAllProperties({
    //  commit, state, dispatch, getters, rootGetters,
    // }) {
    //  axios.get('/core/properties/search').then((res) => {
    //    // Set all properties
    //    commit('setAllproperties', res.data.properties);

    //    if (window.$cookies.get('currentshortlist')) {
    //      const shortlistIDs = JSON.parse(window.$cookies.get('currentshortlist'));
    //      const shortlist = res.data.properties.filter((p) => shortlistIDs.includes(p.id));

    //      // Set/restore shorlist
    //      if (shortlist.length > 0) {
    //        window.vue1.$store.commit('common/updateShortlist', shortlist);
    //      }
    //    }
    //  });
    // },
  },
};
